import {
  calculatePipelineScenario as calculatePipelineScenarioCore,
  GENERATION_CASES as CORE_GENERATION_CASES,
  REFERENCE_SCENARIO as CORE_REFERENCE_SCENARIO,
} from './pipeline-throughput-core.mjs';

export interface ThroughputInputs {
  diameterInches: number;
  lengthMiles: number;
  inletPsig: number;
  outletPsig: number;
  temperatureF: number;
  specificGravity: number;
  compressibility: number;
  baseCompressibility: number;
  roughnessMm: number;
  viscosityPaS: number;
  atmosphericPsia: number;
  basePressurePsia: number;
  baseTemperatureF: number;
  hhvBtuScf: number;
  heatRateBtuKwh: number;
}

export type PipelineScenarioResult =
  | {
      ok: true;
      gasMmscfd: number;
      gasDthDay: number;
      netMw: number;
      massFlowKgS: number;
      reynoldsNumber: number;
      darcyFrictionFactor: number;
      warnings: string[];
    }
  | { ok: false; error: string };

export interface GenerationCase {
  id: string;
  label: string;
  heatRateBtuKwh: number;
  sourceUrl: string;
}

export const REFERENCE_SCENARIO: { version: string; inputs: ThroughputInputs } = CORE_REFERENCE_SCENARIO;
export const GENERATION_CASES: readonly GenerationCase[] = CORE_GENERATION_CASES;
export const calculatePipelineScenario: (inputs: ThroughputInputs) => PipelineScenarioResult =
  calculatePipelineScenarioCore;
